import React, { Fragment, useState, useEffect } from "react";
import { Breadcrumbs, Btn, H4 } from "../../AbstractElements";
import { useSelector } from "react-redux";
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input } from "reactstrap";
import { useNavigate, useParams } from "react-router";
import axios from "axios";
import { toast } from "react-toastify";
import UploadProjectFileClass from "../DealsSection/comp/UploadProjectFile";
import { MultiDropzone } from "../../myConstants/MultiDropzone";

const SingleProgram = () => {
  const { id } = useParams();
  const history = useNavigate();

  const token = useSelector((state) => state.auth.userToken);
  const admin = useSelector((state) => state.auth.userInfo._id);
  const [loader, setLoader] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [images, setImages] = useState([]);
  const [formData, setFormData] = useState({
    description: "",
    workOutName: "",
    image: "",
    video: "",
  });
  console.log("🚀 ~ SingleProgram ~ images:",formData)

  useEffect(() => {
    const fetchSingleExercise = async () => {
      if (id) {
        setLoader(true);
        try {
          const response = await axios.get(
            `https://ovah-1-production.up.railway.app/api/add/getSingleId/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const data = response.data;
          setFormData({
            description: data.description,
            workOutName: data.workOutName,
            image: data.exercisePicUrl,
            video: data.exerciseVideoUrl,
          });
          setImages([{ file: data.exercisePicUrl }]); // Assuming image is a URL
          setLoader(false);
        } catch (error) {
          console.error("Error fetching single exercise:", error);
          setLoader(false);
        }
      }
    };

    fetchSingleExercise();
  }, [id, token]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const handleImageChange = (newImages) => {
    setImages(newImages);
  };
  const handleVideoChange = (e) => {
    const file = e.target.files[0]; // Get the first file selected by the user
    setFormData({
      ...formData,
      video: file, // Store the file object itself, not its URL
    });
  };

  const handleAddOrUpdateExercise = async (e) => {
    e.preventDefault();
    setLoader(true);
  
    const data = new FormData();
    data.append("admin", admin);
    data.append("description", formData.description);
    data.append("workOutName", formData.workOutName);
    data.append("video", formData.video);
    const imageFile = images[0]; // Assuming images[0] contains a File object
    data.append("image", imageFile);


    try {
      let config = {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        },
      };
  
      const apiUrl = id
        ? `https://ovah-1-production.up.railway.app/api/add/editSingle/${id}`
        : `${process.env.REACT_APP_API_BASE_URL}/add/addSingleExercise`;
  
      const method = id ? axios.put : axios.post;
  
      const response = await method(apiUrl, data, config);
  
      if (response.status === 201 || response.status === 200) {
        toast.success(response.data.message);
        setLoader(false);
        setFormSubmitted(true);
        setFormData({
          workOutName: "",
          description: "",
          image: "",
          video: "",
        });
        setImages([]);
        history("/programs");

      }
    } catch (error) {
      console.error("Error adding/updating exercise:", error);
      setLoader(false);
    }
  };
  

  const handleCancel = () => {
    setFormData({
      workOutName: "",
      description: "",
      image: "",
      video: "",
    });
    setImages([]);
  };

  return (
    <Fragment>
      <Breadcrumbs parent="Single" title={id ? "Edit Single" : "Create Single"} mainTitle="Single" />
      {!loader ? (
        <Container fluid={true}>
          <H4>{id ? "Edit Single" : "Create Single"}</H4>
          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <Form className="theme-form" onSubmit={handleAddOrUpdateExercise}>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label for="description">Description</Label>
                          <Input
                            type="text"
                            id="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label for="workOutName">Workout Name</Label>
                          <Input
                            type="text"
                            id="workOutName"
                            value={formData.workOutName}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <FormGroup>
                        <Col sm="12">
                          <Label for="image">Exercise Picture URL</Label>
                          <MultiDropzone
                            id="image"
                            images={images}
                            setImages={handleImageChange}
                          />
                        </Col>
                      </FormGroup>
                    </Row>
                    <Row>
                      <Col sm="12">
                      <FormGroup>
  <Label for="video">Exercise Video</Label>
  <div className="custom-file-upload">
    <input
      type="file"
      id="video"
      accept="video/*"
      onChange={handleVideoChange}
      required={!id} // Only required when adding new exercise
    />
    <label htmlFor="video">{formData.video ? formData.video : "Choose file"}</label>
  </div>
</FormGroup>

                        {/* <FormGroup>
                          <Label for="video">Exercise Video</Label>
                          <Input
                            type="file"
                            id="video"
                            accept="video/*"
                            onChange={handleVideoChange}
                            required={!id} // Only required when adding new exercise
                          />
                        </FormGroup> */}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end">
                          <Btn
                            attrBtn={{
                              color: "success",
                              className: "me-3",
                              type: "submit",
                            }}
                          >
                            {id ? "Edit Single" : "Add Single"}
                          </Btn>
                          <Btn
                            attrBtn={{ color: "warning", type: "button" }}
                            onClick={handleCancel}
                          >
                            Cancel
                          </Btn>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <div>Loading...</div>
      )}
    </Fragment>
  );
};

export default SingleProgram;
